import { Action, Module, VuexModule } from "vuex-module-decorators";
import { RegulationNews } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class RegulationNewsModule extends VuexModule {
    @Action
    [RegulationNews.showNews](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/regulation-news/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [RegulationNews.listNews](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/regulation-news/list`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [RegulationNews.saveNews](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/regulation-news/insert`,values, {headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [RegulationNews.updateNews](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/regulation-news/update`,values, {headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [RegulationNews.deleteNews](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/regulation-news/delete`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [RegulationNews.uploadNewsBanner](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/regulation-news/uploadBanner`,values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [RegulationNews.uploadArticleImage](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/regulation-news/uploadArticleImage`,values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [RegulationNews.removeArticleImage](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/regulation-news/removeArticleImage`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}